import { render, staticRenderFns } from "./Satelite.vue?vue&type=template&id=736cc7a2&"
import script from "./Satelite.vue?vue&type=script&lang=js&"
export * from "./Satelite.vue?vue&type=script&lang=js&"
import style0 from "./Satelite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Satelite.vue"
export default component.exports